import {GameSearchMrGreenMiniOrbitBox} from "./game-search-mr-green-mini-orbit.box";

export const GameSearchMrGreenCisBox = GameSearchMrGreenMiniOrbitBox;